import { z } from 'zod';

export const createCartSchema = z.object({
  name: z.string().min(1, 'Subscription name is required'),
});

export const addItemToCartSchema = z.object({
  itemId: z.string().min(1, 'Please select a supplement'),
  strengthId: z.string().min(1, 'Please select a dose'),
});
